import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import Article from 'src/smoothr-web-app-core/models/Article';
import { defaultsToArticleOption, getBasePrice, numberD, numberToCurrency, sleep } from 'src/smoothr-web-app-core/utils/utils';
import Order from "src/smoothr-web-app-core/models/Order";
import {$e, $EQ} from "codelyzer/angular/styles/chars";
import ArticleCategory from "../../../smoothr-web-app-core/models/ArticleCategory";
import {RepositoryService} from "../../../smoothr-web-app-core/services/repository/repository.service";

@Component({
	selector: 'app-recomendation-article-modal',
	templateUrl: './recomendation-article-modal.component.html',
	styleUrls: ['./recomendation-article-modal.component.scss'],
})
export class RecomendationArticleModalComponent implements OnInit {
	public articlesList: Article[] = [];
	public order: Order;
	isDrinks = false;

	numberToCurrency = numberToCurrency;
	public selectedArticles: { article: Article; quantity: number }[] = [];
	constructor(public modalCtrl: ModalController,
				private repoSvc: RepositoryService,
				private translate: TranslateService, private cdr: ChangeDetectorRef) {}
	static async show(
		modalCtrl: ModalController,
		articlesList: Article[],
		order: Order
	): Promise<{ data: { article: Article; quantity: number}[] }> {
		const modal = await modalCtrl.create({
			component: RecomendationArticleModalComponent,
			cssClass: ['auto-height, recommendation-dialog'],
			componentProps: {
				articlesList,
				order
			},
			showBackdrop: true,
		});
		await modal.present();
		await sleep(100);
		const result = (await modal.onDidDismiss()).data;
		return result;
	}
	ngOnInit() {
		const drinksCategory = this.repoSvc._venue.articleCategories.find(c => (c.name.en.toLowerCase() + c.name.de.toLowerCase()).includes('drink'));
		this.isDrinks = this.articlesList[0].categoryId === drinksCategory._id;
	}
	trackBy(index: number, article: Article) {
		return article._id;
	}

	addArticlesToBasket() {
		this.modalCtrl.dismiss({
			data: this.selectedArticles,
		});
	}


	dismiss() {
		this.modalCtrl.dismiss();
	}

	selectArticle(article: Article) {
		if (!this.selectedArticles.find(it => it.article._id === article._id)) {
			this.selectedArticles.push({ quantity: 1, article: article });
		}
	}

	increaseQuantity(article: Article) {
		const foundIndex = this.selectedArticles.findIndex(it => it.article._id === article._id);
		if (foundIndex >= 0) {
			this.selectedArticles[foundIndex].quantity = this.selectedArticles[foundIndex].quantity + 1;
		}
	}

	decreaseQuantity(article: Article) {
		const foundIndex = this.selectedArticles.findIndex(it => it.article._id === article._id);
		if (foundIndex >= 0) {
			if (this.selectedArticles[foundIndex].quantity === 1) {
				this.selectedArticles = this.selectedArticles.filter(it => it.article._id !== article._id);
			} else {
				this.selectedArticles[foundIndex].quantity = this.selectedArticles[foundIndex].quantity - 1;
			}
		}
	}

	protected readonly Order = Order;
	protected readonly encodeURI = encodeURI;
	protected readonly $EQ = $EQ;
	protected readonly $e = $e;
}
